var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoSidebarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.978,
    height: 17.978,
    viewBox: "0 0 17.978 17.978",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "videoSidebarIcon",
    transform: "translate(-346.893 -171.514)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5255",
    "data-name": "Rectangle 5255",
    width: 16.978,
    height: 16.978,
    rx: 8.489,
    transform: "translate(347.393 172.014)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11262",
    "data-name": "Path 11262",
    d: "M362.883,173.717v6.37l5.027-3.185Z",
    transform: "translate(-9.007 3.6)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoSidebarIcon);
export default __webpack_public_path__ + "static/media/videoSidebarIcon.45ece50ab197599534422b5bf9c68630.svg";
export { ForwardRef as ReactComponent };